import { Channel } from '../../api';
import { RootState } from '../types';

export const channelsSelector = (state: RootState): Channel[] => state.channels.channels;

export const areChannelsLoadedSelector = (state: RootState): boolean => state.channels.loaded;
